export default "__VITE_ASSET__181ab7d5__"